import { useTranslation } from "../../../i18n/I18nContext";
import { LANDING_MAX, LANDING_PAD_X } from "./landingLayout";

export function LandingTestimonials() {
  const { t } = useTranslation();
  const keys = ["one", "two", "three"];

  return (
    <section
      id="testimonials"
      aria-labelledby="testimonials-title"
      className="w-full bg-[#F8FAFF] py-12 sm:py-14 lg:py-[76px]"
    >
      <div className={`${LANDING_MAX} ${LANDING_PAD_X}`}>
        <div className="mb-8 flex flex-col gap-4 text-center sm:mb-10 sm:gap-5 lg:mb-[50px]">
          <h2
            id="testimonials-title"
            className="font-bold leading-[1.3] text-[28px] sm:text-[34px] lg:text-5xl xl:text-[48px]"
          >
            {t("reviews.title")}
          </h2>
          <p className="text-base text-[#4B5563] sm:text-lg lg:text-[20px]">{t("reviews.subtext")}</p>
        </div>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {keys.map((k) => (
            <article
              key={k}
              className="flex flex-col rounded-[24px] border border-[#E3EBFF] bg-white p-5 shadow-figma-card transition-shadow hover:shadow-[0_8px_32px_rgba(58,78,139,0.18)] sm:p-6"
            >
              <p className="flex-1 text-[#374151] text-[15px] leading-relaxed sm:text-base">
                &ldquo;{t(`reviews.${k}.body`)}&rdquo;
              </p>
              <div className="mt-5 border-[#F1F5FF] border-t pt-4">
                <p className="font-semibold text-[#253477]">{t(`reviews.${k}.author`)}</p>
                <p className="text-[#6B7280] text-sm">{t(`reviews.${k}.role`)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
